function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FF0026",
  cx: "12",
  cy: "12",
  r: "12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.2 12.815a2.91 2.91 0 002.133 1.08 2.907 2.907 0 002.128-1.075c1.08.524 2.87 1.613 3.724 2.142.3.186.482.52.482.878v.61c0 .503-.355.932-.839 1.013a37.206 37.206 0 01-5.495.537 37.206 37.206 0 01-5.494-.537A1.017 1.017 0 015 16.45v-.612c0-.358.181-.69.479-.876.85-.531 2.637-1.626 3.722-2.147zM11.334 5c1.907 0 3 1.247 3 3.421 0 2.507-1.43 4.79-3 4.79s-3-2.283-3-4.79c0-2.174 1.094-3.421 3-3.421zm9.098 3.521a.327.327 0 01.471 0c.13.134.13.35 0 .484l-2.666 2.737a.327.327 0 01-.45.02l-1.333-1.025a.347.347 0 01.098-.585.327.327 0 01.33.059l1.099.826z",
  fill: "#FFF"
}))));